<template>
    <div>
        <div v-if="featureResponsiveDashboard" class="box">
            <g-row type="flex" :justify="justify" :gutter="[24, 24]" class="xs-break">
                <template v-if="hasFeatureActivationsReoccurringProposals">
                    <sponsorship-list-item
                        v-for="activation in activations"
                        :key="activation.id"
                        :activation="activation"
                        :hasReocurringProposals="hasFeatureActivationsReoccurringProposals" />
                </template>
                <template v-else>
                    <sponsorship-list-item v-for="brief in $root.briefs" :key="brief.id" :brief="brief" />
                </template>
                <sponsorship-list-item
                    v-for="campaign in $root.campaigns_in_progress"
                    :key="campaign.id"
                    :campaign="campaign"
                    :hasReocurringProposals="hasFeatureActivationsReoccurringProposals"
                />
            </g-row>
        </div>
        <div v-else>
            <template v-if="hasFeatureActivationsReoccurringProposals">
                <activation-list-row v-for="activation in activations" :key="activation.id" type="activation" :object="activation" :hasReocurringProposals="hasFeatureActivationsReoccurringProposals" />
            </template>
            <template v-else>
                <activation-list-row v-for="brief in $root.briefs" :key="brief.id" type="activation_brief" :object="brief" :hasReocurringProposals="hasFeatureActivationsReoccurringProposals" />
            </template>
            <campaign-list-row
                v-for="campaign in $root.campaigns_in_progress"
                :key="campaign.id"
                :campaign="campaign"
            />
        </div>
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import CampaignListRow from './CampaignListRow.vue';
    import ActivationListRow from './ActivationListRow.vue';
    import SponsorshipListItem from './SponsorshipListItem.vue';
    import useFeatureFlagsStore from '../../../../stores/feature-flags';

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'CampaignList',

        /**
         * The child components
         *
         * @type {object}
         */
        components: {
            CampaignListRow,
            ActivationListRow,
            SponsorshipListItem
        },

        setup(props, context) {
            const flags = useFeatureFlagsStore().data;

            const justify = computed(() => {
                return context.root.briefs.length + context.root.campaigns_in_progress.length === 1
                    ? 'space-around'
                    : 'start';
            });

            const activations = computed(() => context.root.activations);

            const hasFeatureActivationsReoccurringProposals = computed(() => (
                flags['activations-reoccurring-proposals'] || false
            ));

            return {
                justify,
                featureResponsiveDashboard: flags['live-site-responsive-dashboard'] || false,
                hasFeatureActivationsReoccurringProposals,
                activations
            };
        }
    };
</script>

<style lang="scss" scoped>
    @media only screen and (max-width: $g-screen-size-xs) {
        .ant-row-flex.xs-break .ant-col {
            width: 100%;
        }
    }
</style>
